<!--
 * @description: 科普践行 愿景列表
 * @Author: Jay
 * @Date: 2021-09-24 16:15:18
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-19 15:22:00
-->
<template>
  <div v-class="'animate__animated animate__fadeInUp'">
    <div class="flex align-center flex-wrap justify-between">
      <div
        class="vision-code flex"
        v-for="(item, index) in visionList"
        :key="index"
      >
        <!-- 左边图片 -->
        <div class="code-img">
          <el-image :src="item.image" fit="fill" :lazy="true"></el-image>
        </div>
        <!-- 右边内容 -->
        <div class="padding flex-sub">
          <h3 class="h3-title">{{ item.name }}</h3>
          <p class="p-essay" v-html="item.content"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VisionListCode",
  props: ["visionList"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.vision-code {
  width: 570px;
  height: 255px;
  margin-bottom: 40px;
  box-shadow: 1px 4px 20px 1px rgb(207, 207, 207);
}
.code-img {
  width: 200px;
  height: 100%;
  overflow: hidden;
  .el-image {
    width: 100%;
    height: 100%;
    transition: all 0.6s;
  }
  .el-image:hover {
    transform: scale(1.4);
  }
}

.h3-title {
  display: inline-block;
  height: 22px;
  padding-bottom: 15px;
  margin-bottom: 18px;
  border-bottom: 1px solid #0779c0;
  line-height: 22px;
  font-size: 20px;
  font-weight: bold;
  vertical-align: top;
}
.p-essay {
  // height: 96px;
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  display: -moz-box;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
}
</style>
